var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'district': _vm.districtIsSelected}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading.district)?_c('div',{staticClass:"statistics__loader-wrapper"},[_c('Spinner')],1):_vm._e()]),(_vm.districtIsSelected)?_c('h2',[_vm._v("Opkomst "+_vm._s(_vm.selectedDistrict.Title.Naam._text))]):_c('h2',[_vm._v("Live statistieken")]),_c('div',{class:['statistics__graph-pie-container']},[(!_vm.districtIsSelected)?_c('div',{staticClass:"statistics__graph-pie statistics__graph-pie--one"},[_c('PieChart',{staticClass:"chart",attrs:{"data":{
        datasets: [
          {
            values: [_vm.liveStatistics.completed, _vm.liveStatistics.total - _vm.liveStatistics.completed],
            color: [_vm.getProvinceSetting.color, 'grey']
          }
        ],
        title: 'Gemeentes binnen',
        labels: ['Binnen', 'Niet binnen'],
      }}})],1):_vm._e(),_c('div',{class:['statistics__graph-pie statistics__graph-pie--two']},[_c('PieChart',{staticClass:"chart",attrs:{"data":{
        datasets: [
          {
            values: [_vm.getTurnupPercentage, Math.round((100 - _vm.getTurnupPercentage) * 10) / 10],
            color: [_vm.getProvinceSetting.color, 'grey']

        }],
        legendPosition: _vm.districtIsSelected ? 'left' : 'top',
        title: !_vm.districtIsSelected ? 'Opkomst' : '',
        labels: ['Gestemd', 'Niet gestemd'],
        unit: '%'
      }}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }